<template>
  <v-sheet class="pa-2 ma-2">
    <v-card-subtitle v-if="title" class="no-dim text-primary">{{ title }}</v-card-subtitle>
    <div class="table-box">
      <transition name="fade" mode="out-in">
        <v-data-table :headers="headers"
                      :items="data"
                      density="compact"
                      :fixed-header="true"
                      height="375px"
                      :items-per-page="0"
                      class="striped-table">
          <template #bottom></template>
          <template v-slot:no-data>
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </template>
        </v-data-table>
      </transition>
    </div>
    <div class="label table-comment" v-if="comment">{{ comment }}</div>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'TableBox',
  props: {
    title: {
      type: String,
      default: undefined
    },
    headers: Array,
    data: Array,
    comment: {
      type: String,
      default: undefined
    },
    visible: Boolean
  }
});
</script>

<style scoped>
.table-box {
  height: 375px;
  text-align: left;
  margin: 10px;
  border-radius: 8px;
  background-color: #364c5b;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 0 2px #c0c0c0; /* Elevated border effect */
}

.table-comment {
  font-size: 0.8em;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
}

.no-dim { opacity: 1 !important; } /* cancels Vuetify's dimming */

.striped-table :deep(tbody tr:nth-child(odd)) {
  background-color: rgba(0, 0, 0, .10);
}
</style>
